import styled from "styled-components";

import { ItemIcon } from "@similarweb/ui-components";

const TOP_COMPANY_LOGO_SIZE = 44;
export const TOP_COMPANY_HEADER_GAP = 12;
export const TOP_COMPANY_TEXT_SHIFT = TOP_COMPANY_LOGO_SIZE + TOP_COMPANY_HEADER_GAP;

export const StyledTopCompanyLogo = styled(ItemIcon)`
    box-shadow: none;
    width: ${TOP_COMPANY_LOGO_SIZE}px;
    height: ${TOP_COMPANY_LOGO_SIZE}px;
`;
